export default "__VITE_ASSET__LGx7H4fD__"